import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

import { GeorgiaDfcsBenefits, ProfileTypes } from "@minicity/core";
import { onMounted, ref, watch } from "vue";
import { DeepPartial } from "@/core/utils";
import SignaturePadField from "@/components/SignaturePadField.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthorizedRepresentativeEditor',
  props: {
    modelValue: null,
    prompt: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  modelValue?: DeepPartial<GeorgiaDfcsBenefits.AuthorizedRepresentative>|null,
  prompt: string,
}



const enabled = ref<boolean|null>(null);
const representative = ref<DeepPartial<GeorgiaDfcsBenefits.AuthorizedRepresentative>>({
  name:"",
  phone:"",
  address: {

  },
  preferredLanguage:"English",
  interpreterNeeded: false
});

const signaturePad = ref(null);

// Event for two-way binding


const onInput = () => {
  console.log("oi", enabled.value, representative.value.address?.state);
  if (enabled.value === true) {
    if (getValidationErrors()) { 
      emit('update:modelValue', undefined);
    } else {
      emit('update:modelValue', {...representative.value});
    }
  } else if (enabled.value === false) {
    emit('update:modelValue', null);
  } else {
    emit('update:modelValue', undefined);
  }
};

onMounted(() => {
  if (props.modelValue === undefined) {
    // Nothing
  } else if (props.modelValue === null) {
    // No representative
    enabled.value = false;
  } else {
    // Representative
    enabled.value = true;
    representative.value = {...props.modelValue};
  }
});

const getSignatureData = () => {
  const pad = signaturePad.value as any;
  console.log("PAD", pad);
  return pad.isSignatureEmpty() ? undefined : pad.getSignatureData() as string;
}

const getValidationErrors = () => {
  if (!enabled.value) return undefined;
  if (representative.value.name!.length == 0) return ["Please enter the representative's name"];
  if (representative.value.address!.number?.length == 0) return ["Please enter the representative's building number / name"];
  if (representative.value.address!.street?.length == 0) return ["Please enter the representative's street"];
  if (representative.value.address!.city?.length == 0) return ["Please enter the representative's city"];
  if (!representative.value.address!.state) return ["Please select the representative's state"];
  if (representative.value.preferredLanguage!.length == 0) return ["Please enter the representative's preferred language"];
}

expose({
    getSignatureData,
    getValidationErrors,
});

return (_ctx: any,_cache: any) => {
  const _component_FormRadioGroupField = _resolveComponent("FormRadioGroupField")!
  const _component_FormTextField = _resolveComponent("FormTextField")!
  const _component_Columns = _resolveComponent("Columns")!
  const _component_FormSelectField = _resolveComponent("FormSelectField")!
  const _component_FormCheckboxField = _resolveComponent("FormCheckboxField")!
  const _component_HalfColumn = _resolveComponent("HalfColumn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FormRadioGroupField, {
      label: __props.prompt,
      options: {'Yes': true, 'No': false},
      modelValue: enabled.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((enabled).value = $event)),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (onInput()))
    }, null, 8, ["label", "modelValue"]),
    (enabled.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_FormTextField, {
            label: "Full Name *",
            modelValue: representative.value.name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((representative.value.name) = $event)),
            trimmed: "",
            autoFocus: "",
            onChange: _cache[3] || (_cache[3] = ($event: any) => (onInput()))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_FormTextField, {
            label: "Phone",
            modelValue: representative.value.phone,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((representative.value.phone) = $event)),
            trimmed: "",
            onChange: _cache[5] || (_cache[5] = ($event: any) => (onInput()))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_Columns, null, {
            default: _withCtx(() => [
              _createVNode(_component_FormTextField, {
                label: "Building Number / Name *",
                modelValue: representative.value.address!.number,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((representative.value.address!.number) = $event)),
                onChange: _cache[7] || (_cache[7] = ($event: any) => (onInput()))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_FormTextField, {
                label: "Street *",
                modelValue: representative.value.address!.street,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((representative.value.address!.street) = $event)),
                trimmed: "",
                onChange: _cache[9] || (_cache[9] = ($event: any) => (onInput()))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Columns, null, {
            default: _withCtx(() => [
              _createVNode(_component_FormTextField, {
                label: "City *",
                modelValue: representative.value.address!.city,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((representative.value.address!.city) = $event)),
                trimmed: "",
                onChange: _cache[11] || (_cache[11] = ($event: any) => (onInput()))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_FormSelectField, {
                label: "State *",
                options: _unref(ProfileTypes).StateNotUnknown,
                allowNullSelection: "",
                modelValue: representative.value.address!.state,
                "onUpdate:modelValue": [
                  _cache[12] || (_cache[12] = ($event: any) => ((representative.value.address!.state) = $event)),
                  _cache[13] || (_cache[13] = ($event: any) => (onInput()))
                ]
              }, null, 8, ["options", "modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_FormTextField, {
            label: "Preferred Language *",
            modelValue: representative.value.preferredLanguage,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((representative.value.preferredLanguage) = $event)),
            trimmed: "",
            onChange: _cache[15] || (_cache[15] = ($event: any) => (onInput()))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_FormCheckboxField, {
            boxLabel: "This person requires an interpreter",
            modelValue: representative.value.interpreterNeeded,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((representative.value.interpreterNeeded) = $event)),
            onChange: _cache[17] || (_cache[17] = ($event: any) => (onInput()))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_HalfColumn, null, {
            default: _withCtx(() => [
              _createVNode(SignaturePadField, {
                style: {"flex-grow":"1.8"},
                class: "mt-5",
                ref_key: "signaturePad",
                ref: signaturePad,
                label: "Please have your authorized representative sign here"
              }, null, 512)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})